import { render, staticRenderFns } from "./MultiChoise.vue?vue&type=template&id=78626943&scoped=true&"
import script from "./MultiChoise.vue?vue&type=script&lang=ts&"
export * from "./MultiChoise.vue?vue&type=script&lang=ts&"
import style0 from "./MultiChoise.vue?vue&type=style&index=0&id=78626943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78626943",
  null
  
)

export default component.exports